export default __webpack_public_path__ + "static/media/logo-animation-light.16cc06d8.gif";